import moment from 'moment';
import fundingDocumentsModal from "../../../../../common/modals/fundingDocumentModal/fundingDocumentModal.component";
import formatCurrency from "format-currency";
import editProjectInfoModal from "../../../../../common/modals/editProjectInfoModal/editProjectInfoModal.component";

class SharedProjectViewController {

  constructor(toastr, $http, $rootScope, $stateParams, $timeout, $uibModal, $state, AuthenticationService) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.$state = $state;
    this.viewReady = false;

    this.revenueButtons = {
      MONTHLY: 'monthly',
      YEARLY: 'yearly',
      ALL_TIME: 'alltime'
    };

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.project = {};
    this.auth = AuthenticationService;
    this.contracts = [];
    this.contract = null;
    this.projectUrl = `${$rootScope.apiHost}/api/admin/projects/${$stateParams.projectId}`;

    this.activeRevenueButton = this.revenueButtons.ALL_TIME;
    this.displayRevenue = '';
    this.monthlyRevenue = 0;
    this.yearlyRevenue = 0;
    this.allTimeRevenue = 0;
    this.projectFunding = 0;
    this.numDocuments = 0;

    this.sortedEmployees = [];
    this.leftEmployees = [];
    this.rightEmployees = [];

    this.activeChargeCodes = 0;
    this.expiredChargeCodes = 0;

    this.dateOpen = false;
    this.showExpiredChargeCodes = false;
    this.addModExpanded = false;

    this.selectedFile = undefined;
    this.modificationDate = undefined;
    this.newFundingBreakdown = {};
    this.currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });

    this.numberFormatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2
    });

    this.documentApiUrl = `${$rootScope.apiHost}/api/admin/projects/${$stateParams.projectId}/fundingdocuments`;
    this.projectDocumentBaseUrl = `${$rootScope.apiHost}/api/admin/projects/${$stateParams.projectId}/documents`;

    this.$http.get($rootScope.apiHost + "/api/admin/contracts", { withCredentials: true })
      .then((response) => {
        this.contracts = response.data || [];
      })
      .catch((error) => {
        console.error('Error loading contracts:', error);
      });

    $rootScope.$watch(() => this.project && this.project.fundingMods, (newVal) => {
      this.numDocuments = (newVal || []).length;
    });
  }

  $onChanges(changes) {
    if (changes.project && changes.project.currentValue && changes.project.currentValue.id) {
      this.initializeFromProject(changes.project.currentValue);
    }
  }

  initializeFromProject(projectData) {
    const self = this;
    this.project = projectData || {};
    this.project.chargeCodes = this.project.chargeCodes || [];
    this.project.fundingBreakdown = this.project.fundingBreakdown || [];
    this.project.unfundedChargeCodes = this.project.unfundedChargeCodes || [];
    this.viewReady = false;

    this.$http.get(self.$rootScope.apiHost + '/api/integrations/qb/customers/' + this.project.contractId + '/projects', { withCredentials: true }).then(function (success) {
      self.quickbooksProjectsForCustomer = success.data;
    }, function () {
      // QuickBooks projects unavailable
    });

    this.contract = null;
    (this.project.chargeCodes || []).forEach(function (chargeCode) {
      if (chargeCode.contract && chargeCode.contract.id === self.project.contractId) {
        self.contract = chargeCode.contract;
      }
    });

    this.buildFinancialData(this.project);
    this.buildFundingChartData(this.project);
    this.initDates();
    this.initChargecodeCounts();
    this.displayRevenue = this.monthlyRevenue;

    setTimeout(function () {
      self.setActiveRevenue(self.allTimeRevenue, self.revenueButtons.ALL_TIME);
    }, 50);

    this.viewReady = true;
  }

  getProjectDisplayName(quickbooksId) {
    let proj = undefined;
    if(this.quickbooksProjectsForCustomer) {
      this.quickbooksProjectsForCustomer.forEach(function (project) {
        if (project.id === quickbooksId) {
          proj = project;
        }
      });
    }

    if(proj) {
      return proj.displayName;
    } else {
      return proj;
    }
  }

  fetchProject(force) {
    let options = {
      withCredentials: true
    };
    if (force) {
      options.headers = {'Cache-Control': 'no-cache'};
    }

    return this.$http.get(this.$rootScope.apiHost + '/api/admin/projects/' + this.$stateParams.projectId, options);
  }

  validateDataChange(parameter, value) {
    return !angular.equals(this.project[parameter], value);
  }

  buildFinancialData(project) {
    this.monthlyRevenue = this.currencyFormatter.format(project.monthlyRevenue);
    this.yearlyRevenue = this.currencyFormatter.format(project.yearlyRevenue);
    this.allTimeRevenue = this.currencyFormatter.format(project.allTimeRevenue);

    if (this.isObligationFundingMode()) {
      return this.loadTotalObligatedFunding(project);
    }

    if (project.fundingBreakdown.length > 0) {
      this.projectFunding = this.getTotalFundedCost(project.fundingBreakdown);
    } else {
      this.projectFunding = project.funding;
    }

    this.applyPercentSpent(project);
    return Promise.resolve(this.projectFunding);
  }

  isObligationFundingMode() {
    return this.fundingMode === 'obligation';
  }

  applyPercentSpent(project) {
    if (!project) {
      return;
    }
    if (!this.projectFunding) {
      project.percentSpent = 0;
      return;
    }
    project.percentSpent = 100 - (((this.projectFunding - project.allTimeRevenue) / this.projectFunding) * 100);
  }

  loadTotalObligatedFunding(project) {
    if (!project || !project.contractId || !project.id) {
      this.projectFunding = 0;
      this.applyPercentSpent(project);
      return Promise.resolve(0);
    }

    const url = `${this.$rootScope.apiHost}/api/admin/contracts/${project.contractId}/funding-obligations`
      + `?page=0&size=10000&sort=periodOfPerformanceName,asc&taskOrderId=${encodeURIComponent(project.id)}`;

    return this.$http.get(url, { withCredentials: true }).then((success) => {
      const payload = success.data || {};
      const page = payload.page || payload;
      const obligations = page.content || [];
      this.projectFunding = obligations.reduce(
        (sum, obligation) => sum + (Number(obligation.obligatedAmount) || 0),
        0
      );
      this.applyPercentSpent(project);
      this.buildFundingChartData(project);
      return this.projectFunding;
    }, () => {
      this.projectFunding = 0;
      this.applyPercentSpent(project);
      this.buildFundingChartData(project);
      return 0;
    });
  }

  currency(value) {
    return formatCurrency(value);
  }

  formatDollars(value) {
    if (typeof value !== 'number') {
      return '$0.00';
    }
    return this.currencyFormatter.format(value);
  }

  checkXEditPermission(permission) {
    let result = false;

    if(this.auth.hasPermission(permission)){
      result = true;
    }

    return result;
  }

  checkPermission(e, permission) {
    if(!this.auth.hasPermission(permission)){
      e.preventDefault();
    }
  }

  canManageFundingDetails() {
    return this.auth.hasPermission('PERM_MANAGE_PROJECT_FUNDING_DETAILS');
  }

  getFundingTableColumnCount() {
    // Always-present columns: line, task, user, charge code, pop start/end, rate,
    // cumulative hours, funded cost, cumulative cost, funding remaining, remaining hours = 12
    let count = 12;
    if (this.project && this.project.costBased) {
      count += 8; // weighted, indirect, fb, fixed fee, fb+fee, funded fee, cum fee, fee remaining
    } else {
      count += 1; // funded hours
    }
    if (this.canManageFundingDetails()) {
      count += 2; // drag handle + actions
    }
    return count;
  }

  getLineRemainingFundingValue(fundingBreakdown) {
    if (!fundingBreakdown || !fundingBreakdown.chargeCode || !fundingBreakdown.chargeCode.popRate) {
      return 0;
    }

    const popRate = fundingBreakdown.chargeCode.popRate;
    if (this.project.costBased || popRate.costBased) {
      return (Number(fundingBreakdown.fundedLabor) || 0)
        - ((Number(fundingBreakdown.cumulativeHours) || 0) * (Number(popRate.fullyBurdenedRate) || 0));
    }

    const funded = (Number(fundingBreakdown.fundedHours) || 0)
      * (Number(popRate.fullyBurdenedRateInclusiveOfFee) || 0);
    const spent = (Number(fundingBreakdown.cumulativeHours) || 0)
      * (Number(popRate.fullyBurdenedRateInclusiveOfFee) || 0);
    return funded - spent;
  }

  getSortedFundingBreakdown() {
    if (!this.project.fundingBreakdown) {
      return [];
    }

    return this.project.fundingBreakdown.slice().sort((a, b) => (a.lineNumber || 0) - (b.lineNumber || 0));
  }

  validateFundingLineNumberBeforeSave(fundingBreakdown, value) {
    const lineNumber = parseInt(value, 10);

    if (!Number.isInteger(lineNumber) || lineNumber < 1) {
      return 'Line numbers must be positive integers.';
    }

    const duplicate = (this.project.fundingBreakdown || []).some((row) => {
      return row.id !== fundingBreakdown.id && Number(row.lineNumber) === lineNumber;
    });

    if (duplicate) {
      return 'Line number already in use.';
    }

    return true;
  }

  validateFundingLineNumberItems(items) {
    if (!items || !items.length) {
      return 'No funding lines to renumber.';
    }

    const allIds = (this.project.fundingBreakdown || []).map((row) => row.id).sort((a, b) => a - b);
    const itemIds = items.map((item) => item.id).sort((a, b) => a - b);

    if (allIds.length !== itemIds.length || !allIds.every((id, index) => id === itemIds[index])) {
      return 'Include all lines and use unique positive line numbers.';
    }

    const lineNumbers = items.map((item) => item.lineNumber);

    if (lineNumbers.some((lineNumber) => !Number.isInteger(lineNumber) || lineNumber < 1)) {
      return 'Line numbers must be positive integers.';
    }

    if (new Set(lineNumbers).size !== lineNumbers.length) {
      return 'Include all lines and use unique positive line numbers.';
    }

    return null;
  }

  applyFundingBreakdownResponse(fundingBreakdown) {
    this.project.fundingBreakdown = fundingBreakdown;
    this.buildFinancialData(this.project);
    this.buildFundingChartData(this.project);
    this.updateDisplayRevenueValue();
  }

  refreshFundingBreakdown() {
    return this.fetchProject(true).then((success) => {
      this.project = success.data;
      return this.buildFinancialData(this.project).then(() => {
        this.buildFundingChartData(this.project);
        this.updateDisplayRevenueValue();
      });
    });
  }

  renumberFundingLines(items) {
    const validationError = this.validateFundingLineNumberItems(items);

    if (validationError) {
      this.toastr.error(validationError, 'ERROR');
      return Promise.reject(validationError);
    }

    return this.$http.patch(
      `${this.$rootScope.apiHost}/api/admin/projects/${this.project.id}/funding/line-numbers`,
      { items },
      { withCredentials: true }
    ).then((response) => {
      this.applyFundingBreakdownResponse(response.data || []);
      this.toastr.success('Funding line numbers updated.');
    }, (failure) => {
      if (failure.status === 400) {
        this.toastr.error('Include all lines and use unique positive line numbers.', 'ERROR');
      } else {
        this.toastr.error('Could not update funding line numbers.', 'ERROR');
      }

      return this.refreshFundingBreakdown();
    });
  }

  updateFundingLineNumber(fundingBreakdown, lineNumber) {
    const parsedLineNumber = parseInt(lineNumber, 10);
    const validationError = this.validateFundingLineNumberBeforeSave(fundingBreakdown, parsedLineNumber);

    if (validationError !== true) {
      this.toastr.error(validationError, 'ERROR');
      return this.refreshFundingBreakdown();
    }

    return this.$http.patch(
      `${this.$rootScope.apiHost}/api/admin/projects/${this.project.id}/funding/${fundingBreakdown.id}`,
      { lineNumber: parsedLineNumber },
      { withCredentials: true }
    ).then((response) => {
      fundingBreakdown.lineNumber = response.data.lineNumber;
      this.project.fundingBreakdown.sort((a, b) => (a.lineNumber || 0) - (b.lineNumber || 0));
      this.buildFinancialData(this.project);
      this.buildFundingChartData(this.project);
      this.updateDisplayRevenueValue();
      this.toastr.success('Funding line number updated.');
    }, (failure) => {
      if (failure.status === 409) {
        this.toastr.error('Line number already in use.', 'ERROR');
      } else {
        this.toastr.error('Could not update funding line number.', 'ERROR');
      }

      return this.refreshFundingBreakdown();
    });
  }

  renumberFundingLinesSequentially() {
    const items = this.getSortedFundingBreakdown().map((row, index) => ({
      id: row.id,
      lineNumber: index + 1
    }));

    return this.renumberFundingLines(items);
  }

  onFundingRowDrop(draggedId, targetId) {
    if (!this.canManageFundingDetails() || !draggedId || draggedId === targetId) {
      return;
    }

    const rows = this.getSortedFundingBreakdown();
    const fromIndex = rows.findIndex((row) => row.id === draggedId);
    const toIndex = rows.findIndex((row) => row.id === targetId);

    if (fromIndex < 0 || toIndex < 0) {
      return;
    }

    const reorderedRows = rows.slice();
    const [movedRow] = reorderedRows.splice(fromIndex, 1);
    reorderedRows.splice(toIndex, 0, movedRow);

    const items = reorderedRows.map((row, index) => ({
      id: row.id,
      lineNumber: index + 1
    }));

    this.renumberFundingLines(items);
  }

  buildFundingChartData(project) {
    let pfund = 0;

    if (this.isObligationFundingMode()) {
      pfund = Number(this.projectFunding) || 0;
    } else if (project.fundingBreakdown.length > 0) {
      project.fundingBreakdown.forEach(function (bd) {
        if (bd.chargeCode.popRate) {
          pfund += (bd.fundedHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
        }
      });
    } else {
      pfund = project.funding;
    }

    const funding = pfund;
    const spent = funding * .01 * project.percentSpent;
    const available = funding - spent;

    this.fundingChart = {
      data: [spent.toFixed(2), available > 0 ? available.toFixed(2) : 0],
      labels: ['Spent', 'Available'],
      colors: [this.getDoughnutColor(project), '#00AABB'],
      options: {
        tooltips: {
          callbacks: {
            label: (t, d) => {
              return d.labels[t.index] + ': ' + this.currencyFormatter.format(d.datasets[t.datasetIndex].data[t.index]);
            }
          }
        },
        elements: {
          center: {
            text: project.percentSpent + '50 %',
            color: '#000000',
            minFontSize: 3,
            fontStyle: 'Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif',
            sidePadding: 8
          },
          arc: {
            borderWidth: 0
          }
        }
      }
    };
  }


  initDates() {
    this.project.startDate = this.project.startDate ? moment(this.project.startDate).toDate() : undefined;
    this.project.completionDate = this.project.completionDate ? moment(this.project.completionDate).toDate() : undefined;

    this.project.chargeCodes.forEach(c => {
      c.effectiveDate = c.effectiveDate ? moment(c.effectiveDate).toDate() : undefined;
      c.expirationDate = c.expirationDate ? moment(c.expirationDate).toDate() : undefined;
    })
  }

  initChargecodeCounts() {
    this.activeChargeCodes = 0;
    this.expiredChargeCodes = 0;
    this.project.chargeCodes.forEach(c => {
      this.expiredChargeCodeFilterFn(c) ? this.activeChargeCodes++ : this.expiredChargeCodes++;
    });
  }

  validateDataChange(object, parameter, value) {
    // return !angular.equals(object[parameter], value);
    return true;
  }


  getDoughnutColor(project) {
    if (project.percentSpent >= 75) {
      return '#c0392b';
    }
    else if (project.percentSpent < 75 && project.percentSpent >= 60) {
      return '#ffd506';
    }
    else {
      return '#62cb31';
    }
  }

  getPercentSpentDisplay() {
    const value = Number(this.project && this.project.percentSpent);
    if (!isFinite(value)) {
      return 0;
    }
    return Math.max(0, Math.min(100, value));
  }

  getPercentSpentBarClass() {
    const percentSpent = this.getPercentSpentDisplay();
    if (percentSpent >= 75) {
      return 'progress-bar-danger';
    }
    if (percentSpent >= 60) {
      return 'progress-bar-warning';
    }
    return 'progress-bar-success';
  }

  setActiveRevenue(value, button) {
    this.displayRevenue = value;
    this.activeRevenueButton = button;
  }

  addNewChargeCode() {
    console.log('clicked on add new charge code');
  }

  addExistingChargeCode() {
    console.log('clicked on associate charge code');
  }

  viewRevenueDetails() {
    console.log('clicked on revenue view details');
  }

  viewFundingDetails() {
    console.log('clicked on funding view details');
  }

  updateDetail(url, parameter, value, type) {
    this.dateOpen = false;
    let obj = {};
    obj[parameter] = value;


    this.$http.patch(url, obj, {withCredentials: true}).then(success => {
      this.fetchProject(true).then(success => {
        this.project = success.data;
        this.buildFinancialData(this.project);
        this.buildFundingChartData(this.project);
        this.updateDisplayRevenueValue();
      });
      this.toastr.success('The ' + type + ' has been updated.');
    }, failure => {
      this.toastr.error('Could not update ' + type, 'ERROR');
    });
  }

  updateProjectDetails(parameter, value) {
    if(value instanceof Date) {
      value.setHours(0,0,0,0);
    }

    this.updateDetail(this.$rootScope.apiHost+'/api/admin/projects/' + this.project.id, parameter, value, 'project');
  }

  updateChargecodeDetails(id, parameter, value) {

    if(parameter === 'effectiveDate' || parameter === 'expirationDate') {
      value = moment(value).format("yyyy-MM-DD"+'T'+"HH:mm:ss.SSS");
      value = value+"Z";
    }


    this.updateDetail(this.$rootScope.apiHost + '/api/admin/projects/' + this.project.id + '/chargecodes/' + id, parameter, value, 'chargecode');

  }


  removeFundingLineItem(fundingBreakdown) {
    this.$http.delete(this.$rootScope.apiHost + '/api/admin/projects/' + this.project.id + '/funding/' + fundingBreakdown.id, {withCredentials: true}).then(success => {
      this.fetchProject(true).then(success => {
        this.project = success.data;
        this.buildFinancialData(this.project);
        this.buildFundingChartData(this.project);
        this.updateDisplayRevenueValue();
      });

      this.toastr.success('Funding Line Item has been Removed.');
    }, failure => {
      this.toastr.error('Could not remove funding line item.', 'ERROR');
    });

  }

  updateFundingBreakdownAttributes(id, parameter, value) {

    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost + '/api/admin/projects/' + this.project.id + '/funding/' + id, obj, {withCredentials: true}).then(success => {
      this.fundingBreakdown = success.data;
    }, failure => {
      this.toastr.error('Could not update funding.', 'ERROR');
    });

    this.$timeout(() => {
      this.initChargecodeCounts();
      this.fetchProject(true).then(success => {
        const project = success.data;
        this.buildFinancialData(project);
        this.buildFundingChartData(project);
        this.updateDisplayRevenueValue();
      });
    }, 200);
  }

  updateDisplayRevenueValue() {
    if (this.activeRevenueButton === this.revenueButtons.MONTHLY) {
      this.displayRevenue = this.monthlyRevenue;
    }
    else if (this.activeRevenueButton === this.revenueButtons.YEARLY) {
      this.displayRevenue = this.yearlyRevenue;
    }
    else if (this.activeRevenueButton === this.revenueButtons.ALL_TIME) {
      this.displayRevenue = this.allTimeRevenue;
    }
  }

  expiredChargeCodeFilterFn(chargeCode) {
    let now = new moment();
    if (!moment(chargeCode.expirationDate).isBefore(now)) {
      return chargeCode;
    }
  }

  removeAtp() {
    this.updateProjectDetails('atpDate', null);
  }


  selectModificationDocument() {
    this.fileSelector.click();
  }






  cancelFundingBreakdown() {
    this.newFundingBreakdown = {};
    this.addLineItem = false;
  }

  addFundingBreakdown(){
    let self = this;
    this.$http.post(this.$rootScope.apiHost+'/api/admin/projects/' + this.project.id + '/funding/breakdown', this.newFundingBreakdown, {withCredentials: true}).then (success => {

      self.fetchProject(true).then(success => {
        this.project = success.data;
        self.buildFinancialData(this.project);
        self.buildFundingChartData(this.project);
        self.updateDisplayRevenueValue();
      });

      self.cancelFundingBreakdown();
    });
  }


  getTotalFundedHours(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      total += bd.fundedHours;
    })

    return this.currency(total);
  }

  getTotalCumulativeHours(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      total += bd.cumulativeHours;
    })

    return this.currency(total);
  }

  getTotalRemainingHours(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      total += (bd.fundedHours - bd.cumulativeHours);
    });

    return this.currency(total);
  }

  getTotalApproximateRemainingHours(fundingBreakdown) {
    let self = this;
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      total += self.getApproximateRemainingHours(bd);
    })

    return this.currency(total);
  }

  getTotalFundedCost(fundingBreakdown) {
    let total = 0;
    (fundingBreakdown || []).forEach(function (bd) {
      const popRate = bd.chargeCode && bd.chargeCode.popRate;
      if (!popRate) {
        return;
      }

      if (popRate.costBased) {
        total += (Number(bd.fundedLabor) || 0) + (Number(bd.fundedFee) || 0);
      } else {
        total += (Number(bd.fundedHours) || 0) * (Number(popRate.fullyBurdenedRateInclusiveOfFee) || 0);
      }
    });

    return total;
  }

  getTotalFundedCostDisplay(fundingBreakdown) {
    return this.currencyFormatter.format(this.getTotalFundedCost(fundingBreakdown));
  }

  getTotalFundedFee(fundingBreakdown) {
    let total = 0;
    let self = this;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate) {
        total += bd.fundedFee;
      }
    })

    return this.currencyFormatter.format(total);
  }

  getTotalCumulativeCost(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate.costBased) {
        total += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRate);
      } else {
        total += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
      }

    })

    return this.currencyFormatter.format(total);
  }

  getTotalCumulativeFee(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate) {
        total += (bd.cumulativeHours * bd.chargeCode.popRate.feeRate);
      }
    })

    return this.currencyFormatter.format(total);
  }

  getTotalFundedLabor(fundingBreakdown) {
    let total = 0;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate) {
        total += bd.fundedLabor;
      }
    })

    return this.currencyFormatter.format(total);
  }

  getTotalRemainingFunding(fundingBreakdown) {

    let totalFund = 0;
    let self = this;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate.costBased) {
        totalFund += (bd.fundedLabor);
      } else {
        totalFund += (bd.fundedHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
      }
    })

    let totalCums = 0;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate.costBased) {
        totalCums += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRate);
      } else {
        totalCums += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
      }
    })



    return this.currencyFormatter.format(totalFund - totalCums);
  }

  getTotalRemainingFundingValue(fundingBreakdown) {
    let totalFund = 0;
    let self = this;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate.costBased) {
        totalFund += (bd.fundedLabor);
      } else {
        totalFund += (bd.fundedHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
      }
    })

    let totalCums = 0;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate.costBased) {
        totalCums += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRate);
      } else {
        totalCums += (bd.cumulativeHours * bd.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee);
      }
    })

    return totalFund - totalCums;
  }

  getTotalRemainingFee(fundingBreakdown) {
    let totalFund = 0;
    let totalCums = 0;
    let self = this;
    fundingBreakdown.forEach(function (bd) {
      if(bd.chargeCode.popRate) {
        totalFund += (bd.fundedFee);
        totalCums += (bd.cumulativeHours * bd.chargeCode.popRate.feeRate);
      }
    })


    return this.currencyFormatter.format(totalFund - totalCums);
  }

  getApproximateRemainingHours(fundingBreakdown) {
    let remainingLaborFunding = fundingBreakdown.fundedLabor - (fundingBreakdown.cumulativeHours * fundingBreakdown.chargeCode.popRate.fullyBurdenedRate);
    let remainingFeeFunding = fundingBreakdown.fundedFee - (fundingBreakdown.cumulativeHours * fundingBreakdown.chargeCode.popRate.feeRate);
    let remainingFunding = remainingLaborFunding + remainingFeeFunding;
    return remainingFunding/fundingBreakdown.chargeCode.popRate.fullyBurdenedRateInclusiveOfFee;
  }

  addUnfundedCode(cc) {
    this.addLineItem = !this.addLineItem;
    this.newFundingBreakdown.chargeCode = cc.chargeCodeId;
    this.newFundingBreakdown.user = cc.userId;
    this.newFundingBreakdown.lineItem = this.project.fundingBreakdown.length + 1;
    this.newFundingBreakdown.fundedHours = cc.hours;
  }

  addAllUnfundedCodes() {
    const codes = (this.project.unfundedChargeCodes || []).slice();
    if (!codes.length || this.addingAllUnfunded) {
      return;
    }

    this.addingAllUnfunded = true;
    let lineItem = (this.project.fundingBreakdown || []).length + 1;
    const url = `${this.$rootScope.apiHost}/api/admin/projects/${this.project.id}/funding/breakdown`;

    let chain = Promise.resolve();
    codes.forEach((cc) => {
      const payload = {
        chargeCode: cc.chargeCodeId,
        user: cc.userId,
        lineItem: lineItem++,
        fundedHours: cc.hours,
        taskName: ''
      };
      chain = chain.then(() => this.$http.post(url, payload, {withCredentials: true}));
    });

    chain.then(() => {
      return this.fetchProject(true).then((success) => {
        this.project = success.data;
        this.buildFinancialData(this.project);
        this.buildFundingChartData(this.project);
        this.updateDisplayRevenueValue();
        this.toastr.success(`Added ${codes.length} charge code(s) to funding`);
      });
    }).catch((failure) => {
      const message = (failure && failure.data && failure.data.message) || 'Failed to add all unfunded charge codes';
      this.toastr.error(message, 'ERROR');
      return this.fetchProject(true).then((success) => {
        this.project = success.data;
        this.buildFinancialData(this.project);
        this.buildFundingChartData(this.project);
        this.updateDisplayRevenueValue();
      });
    }).finally(() => {
      this.$timeout(() => {
        this.addingAllUnfunded = false;
      });
    });
  }


  manageFundingDocuments() {
    let modalInstance = this.$uibModal.open(fundingDocumentsModal)

    modalInstance.fundingMods  = this.project.fundingMods;
    modalInstance.projectId = this.project.id;
    modalInstance.apiHost = this.$rootScope.apiHost;

    modalInstance.cancel = (count) => {
      this.numDocuments = count
      modalInstance.dismiss()
    };

  }

  getWeightedLaborRateForLaborCategory(lcatId) {
    let weightedLaborRate = 0;

    if(this.contract && this.contract.fixedFeeBasis) {
      this.contract.fixedFeeBasis.forEach(function (fixedFeeBasis) {
        if (fixedFeeBasis.laborCategoryId === lcatId) {
          weightedLaborRate = fixedFeeBasis.fullyLoadedLaborRate;
        }
      });
    }

    return weightedLaborRate;
  }

  deleteProject(){
    this.$http.delete(this.$rootScope.apiHost + '/api/admin/projects/' + this.project.id, {withCredentials: true}).then(success => {
      //go to projects page
      this.$state.go('admin.projects');
    }, failure => {
      this.toastr.error(failure.data.message, 'ERROR');
    });
  }

  getInvoiceStatus(invoice) {
    if(invoice) {
      if (invoice.paid) {
        return "Paid";
      } else {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return "Overdue";
        }

        let x = moment(invoice.dueDate).diff(moment(), 'DAYS');
        return "Due in " + x + " days";
      }
    }
  }

  openEditProjectInfoModal() {
    if (!this.checkXEditPermission('PERM_MANAGE_PROJECT_DETAILS')) {
      return;
    }
    
    let self = this;
    
    let modalConfig = {
      template: editProjectInfoModal.template,
      controller: editProjectInfoModal.controller,
      controllerAs: '$ctrl',
      size: 'md',
      windowClass: "hmodal-info animated zoomIn",
      resolve: {
        projectNumber: function() {
          return (self.project && self.project.number) || '';
        },
        projectName: function() {
          return (self.project && self.project.name) || '';
        },
        contractId: function() {
          return (self.project && self.project.contractId) || null;
        },
        contracts: function() {
          return self.contracts || [];
        },
        projectUrl: function() {
          return self.projectUrl;
        }
      }
    };
    
    var modalInstance = this.$uibModal.open(modalConfig);
    
    modalInstance.result.then(function(result) {
      // Update local project with returned values
      if (result.number !== undefined) {
        self.project.number = result.number;
      }
      if (result.name !== undefined) {
        self.project.name = result.name;
      }
      if (result.contractId !== undefined && result.contractId !== self.project.contractId) {
        self.project.contractId = result.contractId;
        // Update contract object if contract changed
        const updatedContract = self.contracts.find(c => c.id === result.contractId);
        if (updatedContract) {
          self.contract = updatedContract;
        }
      }
      self.toastr.success('Project information updated successfully.', 'SUCCESS');
    }, function() {
      // Modal was dismissed
    });
  }

}

export default SharedProjectViewController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/shared-project-view/shared-project-view.controller.js